//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.main`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    & > *:last-child:not(section) {
        position: absolute;
        right: 30px;
        bottom: 30px;
    }
`;
export const Content = styled.section`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 300px;
    & > header {
        position: relative;
        & img {
            width: 70px;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
        & h1 {
            color: var(--light-gray-5);
            text-align: center;
            margin: 0;
        }
    }
`;
export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 10px;
    & footer {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    & > *, footer > * {
        width: 100%;
    }
`;